// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from './App'
import router from '@/router'
import store from '@/store'
import globalMixin from '@/mixins'

import Vuelidate from 'vuelidate'
import VueMq from 'vue-mq'

import { MdField, MdButton, MdMenu, MdList, MdCheckbox, MdSwitch, MdRadio, MdTooltip } from 'vue-material/dist/components'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

import '@fortawesome/fontawesome-free/css/all.min.css'

import '@/assets/scss/utils.scss'
import '@/assets/scss/styles.scss'

import '@/assets/js/observer.js'

import firebase from 'firebase/app'
import 'firebase/analytics'

let pathName = location.pathname
if (!(pathName.includes('reset_password') || pathName.includes('verification'))) {
  Vue.prototype.$analytics = firebase.analytics()
}

Vue.use(VueMq, {
  breakpoints: {
    mobile: 520,
    tablet: 720,
    desktop: Infinity
  },
  defaultBreakpoint: 'desktop'
})

Vue.config.productionTip = false

Vue.use(MdField)
Vue.use(MdButton)
Vue.use(MdMenu)
Vue.use(MdList)
Vue.use(MdCheckbox)
Vue.use(MdSwitch)
Vue.use(MdRadio)
Vue.use(MdTooltip)

Vue.use(Vuelidate)
Vue.mixin(globalMixin)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
